<template>
  <div class="layout_contents">
    <div class="label-title">선박안전 인증</div>
    <!-- Area Info -->
    <div class="area-info">
      <img
        src="@/assets/images/information/facility/dream-safety.png"
        alt="선박 안전성을 위한 인증서"
        class="img-photo"
      />
      <dl class="view-info">
        <dt>선박 안전성을 위한 인증서 획득</dt>
        <dd>
          <ul class="list-dot">
            <li>
              팬스타는 선박의 안전 운항 및 해양 오염 방지를 위하여 국제협약에 따라 각종 필수 증서를 지방해양수산청 및
              한국 선급으로부터 획득하였으며, 정기적인 검사를 통해 자격을 유지하고 있습니다.
            </li>
          </ul>
        </dd>
      </dl>
    </div>
    <!-- //Area Info -->
    <!-- Area Info -->
    <div class="area-info">
      <img
        src="@/assets/images/information/facility/dream-safety2.png"
        alt="국제안전관리규약(ISM Code) 인증서 획득"
        class="img-photo"
      />
      <dl class="view-info">
        <dt>국제안전관리규약(ISM Code) 인증서 획득</dt>
        <dd>
          <ul class="list-dot">
            <li>
              팬스타는 선박의 안전운항을 위해 1998년 국제안전관리규약(ISM Code)에 따른 회사 적합증서(DOC)와
              선박안전경영증서(SMC)를 획득하였으며, 한국선급(KR)으로부터 선박의 안전운항에 대한 정기적인 심사를 받고
              인증 자격을 유지해 오고 있습니다.
            </li>
          </ul>
        </dd>
      </dl>
    </div>
    <!-- //Area Info -->
    <hr class="hr-line" />

    <div class="label-title">선박안전 관리</div>
    <!-- Area Info -->
    <div class="area-info">
      <dl class="view-info">
        <dt>무사고 운항</dt>
        <dd>
          <ul class="list-dot">
            <li>
              팬스타는 전문적인 육상 인력을 바탕으로 한 선박 관리는 물론이며 우수한 선원을 토대로 국제협약(SOLAS 1974,
              MARPOL 1973 등)을 준수하고 무사고 운항을 기록하고 있습니다.
            </li>
          </ul>
        </dd>
        <dt>여객선 정비 및 검사</dt>
        <dd>
          <ul class="list-dot">
            <li>팬스타는 모든 여객선에 대하여 매년 1회 조선소 입거 후 정비 및 검사를 시행하고 있습니다.</li>
          </ul>
        </dd>
        <dt>항만국 검사</dt>
        <dd>
          <ul class="list-dot">
            <li>
              팬스타의 선박은 연간 4회 이상 한국 및 일본 항만국이 실시하는 정기 점검 및 수시 점검을 통해 안전성을
              인정받고 있습니다.
            </li>
          </ul>
        </dd>
        <dt>선내 시설물 및 화물 고박</dt>
        <dd>
          <ul class="list-dot">
            <li>
              팬스타 선박 내의 모든 시설은 기상 영향에도 흔들림 없이 여객의 안전을 보장할 수 있도록 고정되어 있으며
              움직일 수 있는 물건들은 안전하게 고박하고 주기적으로 순찰하고 있습니다.
            </li>
          </ul>
        </dd>
      </dl>
    </div>
    <!-- //Area Info -->

    <hr class="hr-line" />

    <div class="label-title">선박 소화 및 안전 장비 시스템</div>
    <!-- Area Info -->
    <div class="area-info">
      <dl class="view-info">
        <dt>소화설비</dt>
        <dd>
          <ul class="list-dot">
            <li>
              선내 모든 구역에 화재를 탐지할 수 있는 화재 감지시스템(Fire Detection System)이 구축되어 있고 신속하고
              효과적인 화재 진압을 위한 다양한 고정식/이동식 소화 설비를 갖추고 있습니다.
            </li>
          </ul>
        </dd>
        <dt>구명설비</dt>
        <dd>
          <ul class="list-dot">
            <li>
              팬스타의 선박은 비상 상황을 대비하여 모든 여객을 수용할 수 있는 충분한 구명 설비를 갖추고 있으며, 주기적인
              점검을 통해 관리되고 있습니다.
            </li>
          </ul>
        </dd>
        <dt>항해설비</dt>
        <dd>
          <ul class="list-dot">
            <li>
              통합 선교 시스템인 IBS(Intergrated Bridge System)를 설치하여 항해의 안전성 및 효율성을 높이고 있습니다.
            </li>
          </ul>
        </dd>
      </dl>
    </div>
    <!-- //Area Info -->
    <hr class="hr-line" />

    <div class="label-title">비상 대응</div>

    <!-- Area Info -->
    <div class="area-info">
      <img src="@/assets/images/information/facility/dream-emergency.png" alt="비상 대응 훈련" class="img-photo2" />
      <dl class="view-info">
        <dt>비상 대응 훈련</dt>
        <dd>
          <ul class="list-dot">
            <li>
              팬스타는 국제안전 관리규약(ISM Code)에 따라 모든 비상상황을 대비한 선원의 주기적인 훈련을 통해 여객의
              안전을 확보하는 데 노력을 다하고 있습니다.
            </li>
          </ul>
        </dd>
        <dt>비상 대응 시스템</dt>
        <dd>
          <ul class="list-dot">
            <li>
              팬스타 여객선은 해상에서의 비상상황 시 무선 및 위성설비를 이용하여 육상에 조난 사실을 알리고 적절한 지원을
              받을 수 있는 해상 조난 및 안전 시스템(GMDSS; Global Maritime Distress and Safety System)을 갖추고
              있습니다.
            </li>
          </ul>
        </dd>
      </dl>
    </div>
    <!-- //Area Info -->

    <hr class="hr-line" />
    <div class="label-title">선박별 안전 설비 현황</div>

    <table class="table-form">
      <colgroup>
        <col width="500px" />
        <col width="*" />
      </colgroup>
      <thead>
        <tr>
          <th>항목</th>
          <th>세부 내용</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="txt-center">최대 정원</td>
          <td>610명</td>
        </tr>
        <tr>
          <td class="txt-center">구명조끼</td>
          <td>성인용 763개, 어린이용 88개, 유아용18개/총 869명 수용</td>
        </tr>
        <tr>
          <td class="txt-center">구명뗏목</td>
          <td>15정/총 625명 수용</td>
        </tr>
        <tr>
          <td class="txt-center">강하식 탑승장치(Marine Evacuation System)</td>
          <td>1정</td>
        </tr>
        <tr>
          <td class="txt-center">구명부환</td>
          <td>20개</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'DreamSafety',
};
</script>

<style scoped>
.layout_contents {
  width: 100%;
  max-width: 1384px;
  padding: 0 16px;
  margin: 0 auto 100px auto;
}

.label-title {
  font-size: 34px;
  font-weight: 700;
  margin-bottom: 60px;
}

.area-info {
  display: flex;
}

.area-info + .area-info {
  margin-top: 20px;
}

.area-info .img-photo {
  margin-right: 20px;
  width: 150px;
}

.area-info .img-photo2 {
  width: 404px;
  margin-right: 20px;
}

.view-info dt {
  padding-bottom: 20px;
  color: #304da7;
  font-size: 22px;
  line-height: 33px;
  font-weight: 600;
}

.view-info dd + dt {
  margin-top: 20px;
}

.view-info ul.list-dot li {
  position: relative;
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
  color: #686d72;
  margin-left: 20px;
  padding-left: 30px;
}

.view-info ul.list-dot li:before {
  position: absolute;
  top: 13px;
  left: 10px;
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #686d72;
  content: '';
}

.hr-line {
  margin: 60px 0;
  border: none;
  border-bottom: 1px solid #dddfe2;
}
.table-form tr th {
  background: #f5f7f9;
  border: 1px solid #dddfe2;
  color: #686d72;
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  padding: 17px 30px;
}

.table-form tr td {
  border: 1px solid #dddfe2;
  padding: 15px 30px;
  color: #686d72;
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
  text-align: left;
}

.table-form tr td.txt-center {
  text-align: center;
}

.table-form tr td:first-of-type,
.table-form tr th:first-of-type {
  border-left: none;
}

.table-form tr td:last-of-type,
.table-form tr th:last-of-type {
  border-right: none;
}

@media (max-width: 767px) {
  .layout_contents {
    margin: 0 auto 70px auto;
  }

  .label-title {
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 24px;
  }
  .area-info .img-photo {
    width: 120px;
    margin: 0 0 12px 0;
  }
  .area-info {
    flex-direction: column;
  }
  .view-info dt {
    font-size: 18px;
    line-height: 24px;
    padding-bottom: 12px;
  }
  .view-info ul.list-dot li {
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    padding-left: 25px;
    font-weight: normal;
  }
  .view-info ul.list-dot li:before {
    width: 4px;
    height: 4px;
    top: 9px;
  }
  .area-info + .area-info {
    margin-top: 16px;
  }
  .hr-line {
    margin: 24px 0;
  }
  .area-info .img-photo2 {
    width: 100%;
    margin: 0 0 16px 0;
  }

  .table-form tr td:first-of-type {
    width: 50% !important;
  }
  .table-form tr th {
    padding: 17px 0;
    font-size: 16px;
    line-height: 140%;
  }
  .table-form tr td {
    font-size: 16px;
    line-height: 140%;
    font-weight: normal;
    text-align: center;
  }
  .table-form tr td .txt-bar {
    display: none;
  }
  .table-form tr td .br {
    display: block;
  }
}
</style>
